import React from 'react';
import './MenuSingle.css';

import { PageSidebar, PageTitle } from '../../../components';

import { FaCheck, FaNutritionix } from 'react-icons/fa';

import { useLocation } from 'react-router-dom';



const MenuSingle = () => { 

  // Get the menu data from the router state
  const location = useLocation();  
  const menu = location.state; 

  return (
    <>
      {/* Page Title */}
      <PageTitle title={menu.title} page={"Menu Single"} />

      <section className='menu-single page-single'>

        <div className='menu-info page-info'>

          {/* Menu Image */}
          <div className='image'>
            <img src={menu.image} alt={menu.title} />
          </div>

          <div className='content'>

            {/* Menu Title */}
            <h3 className='main-heading'>{menu.title}</h3>

            {/* Menu Description */}
            {menu.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

            <div className='box-container'>

              {/* Menu Ingredients Section */}
              <div className='sub-section'>
                <h3 className='sub-heading'>Ingredients:</h3>

                {/* List of Ingredients */}
                <ul>
                  {menu.ingredients.map((item, index) => (
                    <li key={index}>
                      <div className='icon'><FaCheck/></div>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Menu Nutritions Section */}
              <div className='sub-section'>
                <h3 className='sub-heading'>Nutritions:</h3>
                
                {/* List of Nutritions */}
                <ul>
                  {menu.nutritions.map((item, index) => (
                    <li key={index}>
                      <div className='icon'><FaNutritionix /></div>
                      <strong>{item.label}</strong>
                      {item.value}
                    </li>
                  ))}
                </ul>
              </div>

            </div>

          </div>
        
        </div>

        {/* Sidebar with Menu Details */}
        <PageSidebar
          heading={'Menu'}
          details={menu.details}
        />

      </section>

    </> 
  );
}

export default MenuSingle;